import * as React from "react";
import { MenuButton, IMenuItem, MenuItemType } from "azure-devops-ui/Menu";

export default class MenuExample extends React.Component {
    private menuItems: IMenuItem[] = [
        { id: "one", text: "MenuItem 1" },
        { id: "two", text: "MenuItem 2" },
        { id: "three", text: "MenuItem 3" },
        { id: "separator", itemType: MenuItemType.Divider },
        { id: "four", text: "MenuItem 4" },
        { id: "five", text: "MenuItem 5" }
    ];

    public render(): JSX.Element {
        return (
            <MenuButton
                text="Menu Button"
                contextualMenuProps={{
                    menuProps: {
                        id: "test",
                        items: this.menuItems,
                        onActivate: menuItem => alert("Activate Item - " + menuItem.id)
                    }
                }}
            />
        );
    }
}
